module.exports = "/images/vendor/vue-paycard/src/20.jpg?645f5d5c745ba8cb7ec770172fcba384";